export const SET_CHATROOMS = "SET_CHATROOMS";
export const SET_SOCKET = "SET_SOCKET";
export const MESSAGE_RECEIVED = "MESSAGE_RECEIVED";
export const REMOVE_CHATROOM = "REMOVE_CHATROOM";